module.exports = __webpack_public_path__ + "iconfont.2a604562233d45f863e9.eot";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/iconfont/projectIconfont/iconfont.eot?t=1483974170613
// module id = ../../../../../ng-src/assets/iconfont/projectIconfont/iconfont.eot?t=1483974170613
// module chunks = styles